export default "__VITE_ASSET__4157ff49__"